import { ForgeProjectFeatureArtifact } from "./SDKForgeProjectFeatureArtifact";
export class ForgeProjectFeatureArtifactList {
    constructor(model) {
        this.artifacts = model.artifacts.map((a) => new ForgeProjectFeatureArtifact(a));
    }
    toRemote() {
        return {
            artifacts: this.artifacts.map((a) => a.toRemote()),
        };
    }
}
